export default [
  // 广告收益估算
  {
      path: '/ad/estimatead',
      name: "estimatead",
      component: () => import('../views/ad/estimatead'),
  },
  // 广告收益估算（按广告组)
  {
      path: '/ad/estimateaddetails',
      name: "estimateaddetails",
      component: () => import('../views/ad/estimateaddetails'),
  },
  // 广告收益估算今日（按广告组)
  {
      path: '/ad/adgroup',
      name: "adgroup",
      component: () => import('../views/ad/adgroup'),
  }
]